;((win, doc, $) => {
  'use strict';
  $(function() {

    //
    // smooth scroll
    //
    $(() => {
      $('a[href^="#"]').on('click', function(){
        var $href = $(this).attr("href");
        var $target = $($href == "#" || $href == "" ? 'html' : $href);
        var $point = $target.offset().top;
        var $speed = 400;
        $("html, body").animate({scrollTop: $point}, $speed);
        return false;
      });
    });

    //
    // page top
    //
    $(() => {
      const $btn = $("#js-to-page-top");
      const $headerHeight = $(".js-header").innerHeight();
      const $mvRankingHeight = $(".js-mv-ranking").innerHeight();
      const $point = $headerHeight + $mvRankingHeight;
      const $speed = 400;

      $btn.on("click", function() {
        $("html,body").animate({scrollTop: 0}, $speed);
      });
      $(window).on("scroll", function() {
        if($(window).scrollTop() > $point) {
          $btn.fadeIn();
        }else {
          $btn.fadeOut();
        }
      });
    });

  });
})(window, document, window['jQuery']);